export default __webpack_public_path__ + "static/media/screen_whatsapp_1.9c09c944.png";